import React from "react";
import cartoonFamily from "../../images/cartoonFamily.svg";
import { colors } from "../../constants/colors";

export const LearnMore = () => {
  return (
    <section
      // data-aos="fade-up-right"
      id="learn-more"
      className="learn-more container-fluid"
      style={{ backgroundColor: colors.gencWhite }}
    >
      <div className="row justify-content-around learn-more-container">
        <div
          className="col-md-6 d-flex justify-content-center"
          style={{ padding: "6vw" }}
        >
          <img src={cartoonFamily} alt="Cartoon Family" />
        </div>
        <div
          className="col-md-6"
          style={{ padding: "6vw" }}
          data-aos="fade-left"
          data-delay-aos="250"
        >
          <h1 style={{ color: colors.gencBlue, marginBottom: 0 }}>
            GenC Apps & ML Models For Health
          </h1>
          <hr
            style={{
              width: "50%",
              height: "3px",
              textAlgin: "left",
              backgroundColor: colors.gencBlue,
              marginLeft: 0,
              marginTop: 2,
            }}
          />
          <p style={{ color: colors.gencBlack }}>
            <b>GenC Shell is not just a highly secure storage box</b>, it is
            also a database that you can connect to your subscribed apps and
            recommended machine learning models.
          </p>

          <p style={{ color: colors.gencGrey }}>
            <a
              href="assets/file/angelo_network.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: colors.gencRed }}
            >
              <b>
                <u>Learn more</u>
              </b>
            </a>{" "}
            about the technologies behind GenC Health-Box
          </p>
        </div>
      </div>
    </section>
  );
};
